export function handleOnBlur(e) {
  const target = e.target;
  if (!target.dataset.initialized)
    target.setAttribute('data-initialized', true);
}
